import React, { useState } from 'react';
import {
    Grid, TextField, Button, Typography, CircularProgress, IconButton, Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db, storage } from '../../../firebase/firebase'; // ajusta ruta
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';


const Crear_Blog_Dashboard = () => {

    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [imagen, setImagen] = useState(null);
    const [imagenURL, setImagenURL] = useState('');
    const [secciones, setSecciones] = useState([{ subtitulo: '', parrafo: '' }]);
    const [loading, setLoading] = useState(false);

    const handleImageChange = (e) => {
        setImagen(e.target.files[0]);
    };

    const handleAddSection = () => {
        setSecciones([...secciones, { subtitulo: '', parrafo: '' }]);
    };

    const handleRemoveSection = (index) => {
        const nuevas = secciones.filter((_, i) => i !== index);
        setSecciones(nuevas);
    };

    const handleSectionChange = (index, campo, valor) => {
        const nuevas = [...secciones];
        nuevas[index][campo] = valor;
        setSecciones(nuevas);
    };

    const subirImagenYObtenerURL = async () => {
        if (!imagen) return '';
        const nombreArchivo = `${Date.now()}_${imagen.name}`;
        const imagenRef = ref(storage, `blogs/${nombreArchivo}`);
        await uploadBytes(imagenRef, imagen);
        return await getDownloadURL(imagenRef);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const urlImagen = await subirImagenYObtenerURL();
            await addDoc(collection(db, 'blogs'), {
                titulo,
                descripcion,
                imagenDestacada: urlImagen,
                secciones,
                creadoEn: Timestamp.now()
            });

            // Reiniciar formulario
            setTitulo('');
            setDescripcion('');
            setImagen(null);
            setImagenURL('');
            setSecciones([{ subtitulo: '', parrafo: '' }]);
            alert('Blog creado con éxito');
        } catch (error) {
            console.error('Error al crear blog:', error);
            alert('Hubo un error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container justifyContent="center" sx={{ maxWidth:1400, px:3, mt:20}}>
                <Grid
                    component="form"
                    onSubmit={handleSubmit}
                    container
                    spacing={2}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{ maxWidth: 800, px: 3 }}
                >
                    <Grid container  size={{xs: 12, sm: 12, md: 12}}>
                        <TextField
                            label="Título del blog"
                            fullWidth
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                        />
                    </Grid>

                    <Grid container   size={{xs: 12, sm: 12, md: 12}}>
                        <TextField
                            label="Descripción corta"
                            fullWidth
                            multiline
                            rows={3}
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Button component="label" variant="outlined" fullWidth>
                            Seleccionar imagen destacada
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                        </Button>
                        {imagen && (
                            <Typography variant="body2" mt={1}>
                                {imagen.name}
                            </Typography>
                        )}
                    </Grid>

                    <Grid container justifyContent={'center'}   size={{xs: 12, sm: 12, md: 12}}>
                        <Typography variant="h6">Secciones del blog</Typography>
                    </Grid>

                    {secciones.map((seccion, index) => (
                        <Grid container   size={{xs: 12, sm: 12, md: 12}} key={index}>

                                <TextField
                                    label="Subtítulo"
                                    fullWidth
                                    value={seccion.subtitulo}
                                    onChange={(e) =>
                                        handleSectionChange(index, 'subtitulo', e.target.value)
                                    }
                                />


                            <TextField
                                label="Párrafo"
                                fullWidth
                                multiline
                                rows={3}
                                margin="normal"
                                value={seccion.parrafo}
                                onChange={(e) =>
                                    handleSectionChange(index, 'parrafo', e.target.value)
                                }
                            />
                            <IconButton sx={{}} onClick={() => handleRemoveSection(index)}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    ))}

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Button variant="outlined" onClick={handleAddSection} fullWidth>
                            Agregar sección
                        </Button>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Button type="submit" variant="contained" fullWidth disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : 'Publicar Blog'}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )

}
export default Crear_Blog_Dashboard;